import { Chip, Time, Ai } from "@carbon/icons-react";
import { useTranslation } from "react-i18next";

const AIProcessingBanner = () => {
  const { t } = useTranslation();

  return (
    <div className="relative overflow-hidden bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50 border border-emerald-200/50 rounded-xl shadow-lg mb-6">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/5 via-teal-500/5 to-cyan-500/5"></div>
      <div className="absolute top-0 left-0 -mt-4 -ml-4 w-32 h-32 bg-gradient-to-br from-emerald-400/10 to-teal-400/10 rounded-full blur-2xl"></div>
      <div className="absolute bottom-0 right-0 -mb-4 -mr-4 w-20 h-20 bg-gradient-to-br from-cyan-400/10 to-blue-400/10 rounded-full blur-xl"></div>

      <div className="relative p-6">
        <div className="flex items-start space-x-4">
          {/* Animated AI Icon */}
          <div className="flex-shrink-0">
            <div className="relative w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center shadow-lg">
              <Chip size={24} className="text-white" />
              {/* Pulsing animation */}
              <div className="absolute inset-0 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl animate-pulse opacity-50"></div>
              {/* Rotating sparkles */}
              <div className="absolute -top-1 -right-1 w-4 h-4 bg-yellow-400 rounded-full flex items-center justify-center animate-bounce">
                <Ai size={16} className="w-2 h-2 text-white" />
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center space-x-3 mb-2">
              <h3 className="text-lg font-semibold text-gray-900">
                {t("ai.processing.banner.title")}
              </h3>
              <div className="flex items-center space-x-1">
                <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
                <div
                  className="w-2 h-2 bg-teal-400 rounded-full animate-pulse"
                  style={{ animationDelay: "0.2s" }}
                ></div>
                <div
                  className="w-2 h-2 bg-cyan-400 rounded-full animate-pulse"
                  style={{ animationDelay: "0.4s" }}
                ></div>
              </div>
            </div>

            <p className="text-gray-600 text-sm mb-4 leading-relaxed">
              {t("ai.processing.banner.description")}
            </p>

            {/* Progress indicator */}
            <div className="bg-white/70 backdrop-blur-sm rounded-lg p-4 mb-6 border border-white/20 shadow-sm">
              <div className="flex items-center space-x-3 mb-3">
                <Time size={20} className="text-emerald-600" />
                <div>
                  <h4 className="text-sm font-medium text-gray-900">
                    {t("ai.processing.banner.status.title")}
                  </h4>
                  <p className="text-xs text-gray-500">
                    {t("ai.processing.banner.status.description")}
                  </p>
                </div>
              </div>

              {/* Animated progress bar */}
              <div className="w-full bg-gray-200 rounded-full h-2 mb-2">
                <div
                  className="bg-gradient-to-r from-emerald-500 to-teal-500 h-2 rounded-full animate-pulse"
                  style={{ width: "70%" }}
                ></div>
              </div>

              <div className="flex items-center justify-between text-xs">
                <span className="text-emerald-600 font-medium">
                  {t("ai.processing.banner.status.analyzing")}
                </span>
                <span className="text-gray-500">
                  {t("ai.processing.banner.status.progress")}
                </span>
              </div>
            </div>

            {/* Action Button */}
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-2 text-xs text-gray-500">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <span>{t("ai.processing.banner.status.active")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIProcessingBanner;
